"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTransactionTypeEnum = void 0;
const weavrAuthorizationTypes_enum_1 = require("./weavrAuthorizationTypes.enum");
const weavrSettlementTypes_enum_1 = require("./weavrSettlementTypes.enum");
// This creates a merged enum, but not a type
exports.CardTransactionTypeEnum = Object.assign({}, weavrSettlementTypes_enum_1.WeavrSettlementTypesEnum, weavrAuthorizationTypes_enum_1.WeavrAuthorizationTypesEnum);
